import Command from './_Command';

export default class NullButton extends Command {
    constructor(public readonly key?: string) {
        super({
            Enabled: false,
            Key: key ?? `nullButton-${Math.floor(Math.random() * 10000)}`,
            Path: false,
            Callback: () => {
                return;
            },
        });
    }
}
